import angular from "angular"
import localityModule from "./localityModule"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"

localityModule.controller("localityController",
    ($scope, sourceEntity, entity, localityService, entityEditionService, nlgTagInputIconMap, countryLanguages, $translate, messagesModal, permissionService) => {
        let originalEntity = angular.copy(entity)
        let canEditGeolocation = true
        permissionService.canRead("group.r2.edit.geocode")
            .then((permission) => canEditGeolocation = permission)
        $scope.defaultCountry = countryLanguages.findByLanguage($translate.use()).iso2
        $scope.model = {
            countryData: null
        }

        const updateService = entityEditionService.crudHelper("locality", sourceEntity)
        $scope.entity = entity
        $scope.executionDTO = entity.executionDTO
        $scope.restriction = {
            enabled: !!entity.r2DeliveryRestriction
        }

        localityService.findPossibleIncompatibleVehicles().then((vehicles) => {
            $scope.vehicles = vehicles
        })

        localityService.findPossibleAllowedTrucks().then((trucks) => {
            $scope.trucks = trucks
        })


        localityService.findPreDefinedWorkingHours()
            .then((preDefinedWorkingHours) => {
                $scope.preDefinedWorkingHours = preDefinedWorkingHours
            })

        $scope.logisticRoles = [
            "br.com.neolog.model.LogisticRole.BOTH",
            "br.com.neolog.model.LogisticRole.DESTINATION",
            "br.com.neolog.model.LogisticRole.ORIGIN"
        ]

        let oldLogisticRole = $scope.entity.logisticRole

        $scope.getLogisticRoles = () => {
            return arrays.filter($scope.logisticRoles, (logisticRole) => {
                if (!$scope.entity.id) {
                    return true
                }
                return [oldLogisticRole, "br.com.neolog.model.LogisticRole.BOTH"].indexOf(logisticRole) !== -1
            })
        }

        $scope.isOrigin = () => {
            return $scope.entity.logisticRole === "br.com.neolog.model.LogisticRole.ORIGIN"
        }

        $scope.onRestrictionChanged = () => {
            if ($scope.restriction.enabled) {
                $scope.entity.r2DeliveryRestriction = null
            }
        }

        $scope.save = () => {
            updateService.save(entity)
        }
        $scope.saveAndContinue = () => {
            updateService.save(entity, true)
        }

        $scope.canChangeGeocode = function () {
            if (!originalEntity.id || canEditGeolocation) {
                return true
            }
            return !canEditGeolocation && (!originalEntity.address.geographicInfo?.latitude && !originalEntity.address.geographicInfo?.longitude)
        }

        $scope.onLatLongChanged = function () {
            $scope.entity.address.geocodificationType = "br.com.neolog.model.GeocodificationType.MANUAL"
        }

        $scope.getLocalityIcons = function () {
            return localityService.getLocalityIcons()
        }

        $scope.getIconPreview = function () {
            if ($scope.executionDTO) {
                return nlgTagInputIconMap.iconMapBig()[$scope.executionDTO.icon]
            }
        }

        $scope.geographicInfoCallback = function () {
            return markersHereApi.centerMapOnMarkers()
        }

        function getGeographicInfo() {
            if ($scope.entity.address.geographicInfo) {
                return $scope.entity.address.geographicInfo
            }
            $scope.entity.address.geographicInfo = {
                latitude: 0,
                longitude: 0
            }
            return $scope.entity.address.geographicInfo
        }

        function getId() {
            if ($scope.entity.id) {
                return $scope.entity.id
            }
            return "new"
        }

        let markersHereApi = null
        $scope.onRegisterHereApi = (api) => {
            markersHereApi = api
        }

        $scope.markersPoints = [{
            geographicInfo: getGeographicInfo(),
            data: {
                id: getId(),
                icon: "images/marker-pin.png",
                geographicInfo: getGeographicInfo()
            }
        }]

        $scope.$watch("entity.address.geographicInfo", function () {
            if (!markersHereApi) {
                return
            }
            markersHereApi.syncGeographicInfo(getGeographicInfo(), getId())
        }, true)

    }
)